export const getFullCountryList = () => {
	return fullCountryList.sort((a, b) => {
		if (a.text < b.text) return -1;
		if (a.text > b.text) return 1;
		return 0;
	});
};

export const getCountryCode = (countryName: string) => {
	const country = getFullCountryList().find((x) => x.text === countryName);
	if (country !== undefined) {
		return country.value;
	}
	return countryName; // Return country name if can't find it in the country list.
};

export const getCountryName = (countryCode: string) => {
	const country = getFullCountryList().find((x) => x.value === countryCode);
	if (country !== undefined) {
		return country.text;
	}
	return countryCode; // Return country code if can't find it in the country list.
};

export const getCountryNameForMobileCode = (countryMobileCode: string) => {
	const countryCode = getThreeLetterCode(countryMobileCode);
	return getCountryName(countryCode);
};

const aring = '\u00C5'; // Å
const eacute = '\u00E9'; // é
const ocirc = '\u00F4'; // ô

// See master-country-list.md for details
const fullCountryList = [
	{ value: 'AFG', text: 'Afghanistan' },
	{ value: 'ALA', text: `${aring}land Islands` },
	{ value: 'ALB', text: 'Albania' },
	{ value: 'DZA', text: 'Algeria' },
	{ value: 'ASM', text: 'American Samoa' },
	{ value: 'AND', text: 'Andorra' },
	{ value: 'AGO', text: 'Angola' },
	{ value: 'AIA', text: 'Anguilla' },
	{ value: 'ATA', text: 'Antarctica' },
	{ value: 'ATG', text: 'Antigua and Barbuda' },
	{ value: 'ARG', text: 'Argentina' },
	{ value: 'ARM', text: 'Armenia' },
	{ value: 'ABW', text: 'Aruba' },
	{ value: 'ASC', text: 'Ascension Island' },
	{ value: 'AUS', text: 'Australia' },
	{ value: 'AUT', text: 'Austria' },
	{ value: 'AZE', text: 'Azerbaijan' },
	{ value: 'BHS', text: 'Bahamas' },
	{ value: 'BHR', text: 'Bahrain' },
	{ value: 'BGD', text: 'Bangladesh' },
	{ value: 'BRB', text: 'Barbados' },
	{ value: 'BRD', text: 'Barbados' },
	{ value: 'BLR', text: 'Belarus' },
	{ value: 'BEL', text: 'Belgium' },
	{ value: 'BLZ', text: 'Belize' },
	{ value: 'BEN', text: 'Benin' },
	{ value: 'BMU', text: 'Bermuda' },
	{ value: 'BTN', text: 'Bhutan' },
	{ value: 'BOL', text: 'Bolivia (Plurinational State of)' },
	{ value: 'BES', text: 'Bonaire, Sint Eustatius and Saba' },
	{ value: 'BIH', text: 'Bosnia and Herzegovina' },
	{ value: 'BWA', text: 'Botswana' },
	{ value: 'BVT', text: 'Bouvet Island' },
	{ value: 'BRA', text: 'Brazil' },
	{ value: 'GBO', text: 'British - National Overseas' },
	{ value: 'GBS', text: 'British - Subject' },
	{ value: 'ATB', text: 'British Antarctic Territory' },
	{ value: 'IOT', text: 'British Indian Ocean Territory' },
	{ value: 'BRN', text: 'Brunei Darussalam' },
	{ value: 'BGR', text: 'Bulgaria' },
	{ value: 'BFA', text: 'Burkina Faso' },
	{ value: 'BUR', text: 'Burma' },
	{ value: 'BDI', text: 'Burundi' },
	{ value: 'BYS', text: 'Byelorussian SSR' },
	{ value: 'CPV', text: 'Cabo Verde' },
	{ value: 'KHM', text: 'Cambodia' },
	{ value: 'CMR', text: 'Cameroon' },
	{ value: 'CAN', text: 'Canada' },
	{ value: 'CTE', text: 'Canton and Enderbury Islands' },
	{ value: 'CYM', text: 'Cayman Islands' },
	{ value: 'CAF', text: 'Central African Republic' },
	{ value: 'TCD', text: 'Chad' },
	{ value: 'CHL', text: 'Chile' },
	{ value: 'CHN', text: 'China' },
	{ value: 'CXR', text: 'Christmas Island' },
	{ value: 'CPT', text: 'Clipperton Island' },
	{ value: 'CCK', text: 'Cocos (Keeling) Islands' },
	{ value: 'COL', text: 'Colombia' },
	{ value: 'COM', text: 'Comoros' },
	{ value: 'COG', text: 'Congo' },
	{ value: 'COD', text: 'Congo, Democratic Republic of the' },
	{ value: 'COK', text: 'Cook Islands' },
	{ value: 'CRI', text: 'Costa Rica' },
	{ value: 'CIV', text: `C${ocirc}te d'Ivoire` },
	{ value: 'HRV', text: 'Croatia' },
	{ value: 'CUB', text: 'Cuba' },
	{ value: 'CUW', text: 'Curaçao' },
	{ value: 'CYP', text: 'Cyprus' },
	{ value: 'CZE', text: 'Czechia' },
	{ value: 'CSK', text: 'Czechoslovakia' },
	{ value: 'DHY', text: 'Dahomey' },
	{ value: 'DNK', text: 'Denmark' },
	{ value: 'DGA', text: 'Diego Garcia' },
	{ value: 'DJI', text: 'Djibouti' },
	{ value: 'DMA', text: 'Dominica' },
	{ value: 'DOM', text: 'Dominican Republic' },
	{ value: 'ATN', text: 'Dronning Maud Land' },
	{ value: 'TMP', text: 'East Timor' },
	{ value: 'ECU', text: 'Ecuador' },
	{ value: 'EGY', text: 'Egypt' },
	{ value: 'SLV', text: 'El Salvador' },
	{ value: 'GNQ', text: 'Equatorial Guinea' },
	{ value: 'ERI', text: 'Eritrea' },
	{ value: 'EST', text: 'Estonia' },
	{ value: 'SWZ', text: 'Eswatini' },
	{ value: 'ETH', text: 'Ethiopia' },
	{ value: 'FLK', text: 'Falkland Islands (Malvinas)' },
	{ value: 'FRO', text: 'Faroe Islands' },
	{ value: 'FJI', text: 'Fiji' },
	{ value: 'FIN', text: 'Finland' },
	{ value: 'FRA', text: 'France' },
	{ value: 'FXX', text: 'France, Metropolitan' },
	{ value: 'AFI', text: 'French Afars and Issas' },
	{ value: 'GUF', text: 'French Guiana' },
	{ value: 'PYF', text: 'French Polynesia' },
	{ value: 'ATF', text: 'French Southern Territories' },
	{ value: 'GAB', text: 'Gabon' },
	{ value: 'GMB', text: 'Gambia' },
	{ value: 'GEO', text: 'Georgia' },
	{ value: 'DDR', text: 'German Democratic Republic' },
	{ value: 'DEU', text: 'Germany' },
	{ value: 'GHA', text: 'Ghana' },
	{ value: 'GIB', text: 'Gibraltar' },
	{ value: 'GEL', text: 'Gilbert and Ellice Islands' },
	{ value: 'GBN', text: 'Great Britain - National Overseas' },
	{ value: 'GRC', text: 'Greece' },
	{ value: 'GRL', text: 'Greenland' },
	{ value: 'GRD', text: 'Grenada' },
	{ value: 'GLP', text: 'Guadeloupe' },
	{ value: 'GUM', text: 'Guam' },
	{ value: 'GTM', text: 'Guatemala' },
	{ value: 'GGY', text: 'Guernsey' },
	{ value: 'GIN', text: 'Guinea' },
	{ value: 'GNB', text: 'Guinea-Bissau' },
	{ value: 'GUY', text: 'Guyana' },
	{ value: 'HTI', text: 'Haiti' },
	{ value: 'HMD', text: 'Heard Island and McDonald Islands' },
	{ value: 'VAT', text: 'Holy See' },
	{ value: 'HND', text: 'Honduras' },
	{ value: 'HKG', text: 'Hong Kong' },
	{ value: 'HUN', text: 'Hungary' },
	{ value: 'ISL', text: 'Iceland' },
	{ value: 'IND', text: 'India' },
	{ value: 'IDN', text: 'Indonesia' },
	{ value: 'IRN', text: 'Iran (Islamic Republic of)' },
	{ value: 'IRQ', text: 'Iraq' },
	{ value: 'IRL', text: 'Ireland' },
	{ value: 'IMN', text: 'Isle of Man' },
	{ value: 'ISR', text: 'Israel' },
	{ value: 'ITA', text: 'Italy' },
	{ value: 'JAM', text: 'Jamaica' },
	{ value: 'JPN', text: 'Japan' },
	{ value: 'JEY', text: 'Jersey' },
	{ value: 'JTN', text: 'Johnston Island' },
	{ value: 'JOR', text: 'Jordan' },
	{ value: 'KAZ', text: 'Kazakhstan' },
	{ value: 'KEN', text: 'Kenya' },
	{ value: 'KIR', text: 'Kiribati' },
	{ value: 'PRK', text: "Korea (Democratic People's Republic of)" },
	{ value: 'KOR', text: 'Korea, Republic of' },
	{ value: 'XKX', text: 'Kosovo' },
	{ value: 'KWT', text: 'Kuwait' },
	{ value: 'KGZ', text: 'Kyrgyzstan' },
	{ value: 'LAO', text: "Lao People's Democratic Republic" },
	{ value: 'LVA', text: 'Latvia' },
	{ value: 'LBN', text: 'Lebanon' },
	{ value: 'LSO', text: 'Lesotho' },
	{ value: 'LBR', text: 'Liberia' },
	{ value: 'LBY', text: 'Libya' },
	{ value: 'LIE', text: 'Liechtenstein' },
	{ value: 'LTU', text: 'Lithuania' },
	{ value: 'LUX', text: 'Luxembourg' },
	{ value: 'MAC', text: 'Macao' },
	{ value: 'MDG', text: 'Madagascar' },
	{ value: 'MWI', text: 'Malawi' },
	{ value: 'MYS', text: 'Malaysia' },
	{ value: 'MDV', text: 'Maldives' },
	{ value: 'MLI', text: 'Mali' },
	{ value: 'MLT', text: 'Malta' },
	{ value: 'MHL', text: 'Marshall Islands' },
	{ value: 'MTQ', text: 'Martinique' },
	{ value: 'MRT', text: 'Mauritania' },
	{ value: 'MUS', text: 'Mauritius' },
	{ value: 'MYT', text: 'Mayotte' },
	{ value: 'MEX', text: 'Mexico' },
	{ value: 'FSM', text: 'Micronesia (Federated States of)' },
	{ value: 'MID', text: 'Midway Islands' },
	{ value: 'MDA', text: 'Moldova, Republic of' },
	{ value: 'MCO', text: 'Monaco' },
	{ value: 'MNG', text: 'Mongolia' },
	{ value: 'MNE', text: 'Montenegro' },
	{ value: 'MSR', text: 'Montserrat' },
	{ value: 'MAR', text: 'Morocco' },
	{ value: 'MOZ', text: 'Mozambique' },
	{ value: 'MMR', text: 'Myanmar' },
	{ value: 'NAM', text: 'Namibia' },
	{ value: 'NRU', text: 'Nauru' },
	{ value: 'NPL', text: 'Nepal' },
	{ value: 'NLD', text: 'Netherlands' },
	{ value: 'ANT', text: 'Netherlands Antilles' },
	{ value: 'NTZ', text: 'Neutral Zone' },
	{ value: 'NCL', text: 'New Caledonia' },
	{ value: 'NHB', text: 'New Hebrides' },
	{ value: 'NZL', text: 'New Zealand' },
	{ value: 'NIC', text: 'Nicaragua' },
	{ value: 'NER', text: 'Niger' },
	{ value: 'NGA', text: 'Nigeria' },
	{ value: 'NIU', text: 'Niue' },
	{ value: 'NFK', text: 'Norfolk Island' },
	{ value: 'MKD', text: 'North Macedonia' },
	{ value: 'MNP', text: 'Northern Mariana Islands' },
	{ value: 'NOR', text: 'Norway' },
	{ value: 'OMN', text: 'Oman' },
	{ value: 'OTH', text: 'Other Australian Territories' },
	{ value: 'PCI', text: 'Pacific Islands (Trust Territory)' },
	{ value: 'PAK', text: 'Pakistan' },
	{ value: 'PLW', text: 'Palau' },
	{ value: 'PSE', text: 'Palestine, State of' },
	{ value: 'PAN', text: 'Panama' },
	{ value: 'PCZ', text: 'Panama Canal Zone' },
	{ value: 'PNG', text: 'Papua New Guinea' },
	{ value: 'PRY', text: 'Paraguay' },
	{ value: 'PER', text: 'Peru' },
	{ value: 'PHL', text: 'Philippines' },
	{ value: 'PHI', text: 'Philippines – Code changed to PHL' },
	{ value: 'PCN', text: 'Pitcairn' },
	{ value: 'POL', text: 'Poland' },
	{ value: 'PRT', text: 'Portugal' },
	{ value: 'PRI', text: 'Puerto Rico' },
	{ value: 'QAT', text: 'Qatar' },
	{ value: 'REU', text: `R${eacute}union` },
	{ value: 'ROU', text: 'Romania' },
	{ value: 'ROM', text: 'Romania' },
	{ value: 'RUS', text: 'Russian Federation' },
	{ value: 'RWA', text: 'Rwanda' },
	{ value: 'BLM', text: `Saint Barth${eacute}lemy` },
	{ value: 'SHN', text: 'Saint Helena, Ascension and Tristan da Cunha' },
	{ value: 'KNA', text: 'Saint Kitts and Nevis' },
	{ value: 'LCA', text: 'Saint Lucia' },
	{ value: 'MAF', text: 'Saint Martin (French part)' },
	{ value: 'SPM', text: 'Saint Pierre and Miquelon' },
	{ value: 'VCT', text: 'Saint Vincent and the Grenadines' },
	{ value: 'WSM', text: 'Samoa' },
	{ value: 'SMR', text: 'San Marino' },
	{ value: 'STP', text: 'Sao Tome and Principe' },
	{ value: 'SAU', text: 'Saudi Arabia' },
	{ value: 'SEN', text: 'Senegal' },
	{ value: 'SRB', text: 'Serbia' },
	{ value: 'SCG', text: 'Serbia and Montenegro' },
	{ value: 'SYC', text: 'Seychelles' },
	{ value: 'SLE', text: 'Sierra Leone' },
	{ value: 'SKM', text: 'Sikkim' },
	{ value: 'SGP', text: 'Singapore' },
	{ value: 'SXM', text: 'Sint Maarten (Dutch part)' },
	{ value: 'SVK', text: 'Slovakia' },
	{ value: 'SVN', text: 'Slovenia' },
	{ value: 'SLB', text: 'Solomon Islands' },
	{ value: 'SOM', text: 'Somalia' },
	{ value: 'ZAF', text: 'South Africa' },
	{ value: 'SGS', text: 'South Georgia and the South Sandwich Islands' },
	{ value: 'SSD', text: 'South Sudan' },
	{ value: 'RHO', text: 'Southern Rhodesia' },
	{ value: 'ESP', text: 'Spain' },
	{ value: 'LKA', text: 'Sri Lanka' },
	{ value: 'SDN', text: 'Sudan' },
	{ value: 'SUR', text: 'Suriname' },
	{ value: 'SJM', text: 'Svalbard and Jan Mayen' },
	{ value: 'SWE', text: 'Sweden' },
	{ value: 'CHE', text: 'Switzerland' },
	{ value: 'SYR', text: 'Syrian Arab Republic' },
	{ value: 'TWN', text: 'Taiwan' },
	{ value: 'TJK', text: 'Tajikistan' },
	{ value: 'TZA', text: 'Tanzania, United Republic of' },
	{ value: 'THA', text: 'Thailand' },
	{ value: 'TLS', text: 'Timor-Leste' },
	{ value: 'TGO', text: 'Togo' },
	{ value: 'TKL', text: 'Tokelau' },
	{ value: 'TON', text: 'Tonga' },
	{ value: 'TTO', text: 'Trinidad and Tobago' },
	{ value: 'TAA', text: 'Tristan da Cunha' },
	{ value: 'TUN', text: 'Tunisia' },
	{ value: 'TUR', text: 'Turkiye' },
	{ value: 'TKM', text: 'Turkmenistan' },
	{ value: 'TCA', text: 'Turks and Caicos Islands' },
	{ value: 'TUV', text: 'Tuvalu' },
	{ value: 'UGA', text: 'Uganda' },
	{ value: 'UKR', text: 'Ukraine' },
	{ value: 'ARE', text: 'United Arab Emirates' },
	{ value: 'GBR', text: 'United Kingdom' },
	{ value: 'UMI', text: 'United States Minor Outlying Islands' },
	{ value: 'PUS', text: 'United States Miscellaneous Pacific Islands' },
	{ value: 'USA', text: 'United States of America' },
	{ value: 'HVO', text: 'Upper Volta' },
	{ value: 'URY', text: 'Uruguay' },
	{ value: 'SUN', text: 'USSR' },
	{ value: 'UZB', text: 'Uzbekistan' },
	{ value: 'VUT', text: 'Vanuatu' },
	{ value: 'VEN', text: 'Venezuela (Bolivarian Republic of)' },
	{ value: 'VNM', text: 'Viet Nam' },
	{ value: 'VDR', text: 'Viet-Nam, Democratic Republic of' },
	{ value: 'VGB', text: 'Virgin Islands (British)' },
	{ value: 'VIR', text: 'Virgin Islands (U.S.)' },
	{ value: 'WAK', text: 'Wake Island' },
	{ value: 'WLF', text: 'Wallis and Futuna' },
	{ value: 'ESH', text: 'Western Sahara' },
	{ value: 'YEM', text: 'Yemen' },
	{ value: 'YMD', text: 'Yemen, Democratic' },
	{ value: 'YUG', text: 'Yugoslavia' },
	{ value: 'ZAR', text: 'Zaire' },
	{ value: 'ZMB', text: 'Zambia' },
	{ value: 'ZWE', text: 'Zimbabwe' }
];

export const countryCodeMap: Record<string, string> = {
	AFG: 'AF',
	ALA: 'AX',
	ALB: 'AL',
	DZA: 'DZ',
	ASM: 'AS',
	AND: 'AD',
	AGO: 'AO',
	AIA: 'AI',
	ATA: 'AQ',
	ATG: 'AG',
	ARG: 'AR',
	ARM: 'AM',
	ABW: 'AW',
	ASC: 'AC',
	AUS: 'AU',
	AUT: 'AT',
	AZE: 'AZ',
	BHS: 'BS',
	BHR: 'BH',
	BGD: 'BD',
	BRB: 'BB',
	BLR: 'BY',
	BEL: 'BE',
	BLZ: 'BZ',
	BEN: 'BJ',
	BMU: 'BM',
	BTN: 'BT',
	BOL: 'BO',
	BES: 'BQ',
	BIH: 'BA',
	BWA: 'BW',
	BVT: 'BV',
	BRA: 'BR',
	BRN: 'BN',
	BGR: 'BG',
	BFA: 'BF',
	BUR: 'MM',
	BDI: 'BI',
	BY: 'BY',
	CPV: 'CV',
	KHM: 'KH',
	CMR: 'CM',
	CAN: 'CA',
	CTE: 'CT',
	CYM: 'KY',
	CAF: 'CF',
	TCD: 'TD',
	CHL: 'CL',
	CHN: 'CN',
	CXR: 'CX',
	CPT: 'CP',
	CCK: 'CC',
	COL: 'CO',
	COM: 'KM',
	COG: 'CG',
	COD: 'CD',
	COK: 'CK',
	CRI: 'CR',
	CIV: 'CI',
	HRV: 'HR',
	CUB: 'CU',
	CUW: 'CW',
	CYP: 'CY',
	CZE: 'CZ',
	CSK: 'CS',
	DHY: 'DH',
	DNK: 'DK',
	DGA: 'DG',
	DJI: 'DJ',
	DMA: 'DM',
	ATN: 'AT',
	TMP: 'TL',
	ECU: 'EC',
	EGY: 'EG',
	SLV: 'SV',
	GNQ: 'GQ',
	ERI: 'ER',
	EST: 'EE',
	SWZ: 'SZ',
	ETH: 'ET',
	FLK: 'FK',
	FRO: 'FO',
	FJI: 'FJ',
	FIN: 'FI',
	FRA: 'FR',
	FXX: 'FR',
	AFI: 'AF',
	GUF: 'GF',
	PYF: 'PF',
	ATF: 'TF',
	GAB: 'GA',
	GMB: 'GM',
	GEO: 'GE',
	DDR: 'DD',
	DEU: 'DE',
	GHA: 'GH',
	GIB: 'GI',
	GEL: 'GE',
	GBN: 'GB',
	GRC: 'GR',
	GRL: 'GL',
	GRD: 'GD',
	GLP: 'GP',
	GUM: 'GU',
	GTM: 'GT',
	GGY: 'GG',
	GIN: 'GN',
	GNB: 'GW',
	GUY: 'GY',
	HTI: 'HT',
	HMD: 'HM',
	VAT: 'VA',
	HND: 'HN',
	HKG: 'HK',
	HUN: 'HU',
	ISL: 'IS',
	IND: 'IN',
	IDN: 'ID',
	IRN: 'IR',
	IRQ: 'IQ',
	IRL: 'IE',
	IMN: 'IM',
	ISR: 'IL',
	ITA: 'IT',
	JAM: 'JM',
	JPN: 'JP',
	JEY: 'JE',
	JTN: 'JT',
	JOR: 'JO',
	KAZ: 'KZ',
	KEN: 'KE',
	KIR: 'KI',
	PRK: 'KP',
	KOR: 'KR',
	XKX: 'XK',
	KWT: 'KW',
	KGZ: 'KG',
	LAO: 'LA',
	LVA: 'LV',
	LBN: 'LB',
	LSO: 'LS',
	LBR: 'LR',
	LBY: 'LY',
	LIE: 'LI',
	LTU: 'LT',
	LUX: 'LU',
	MAC: 'MO',
	MDG: 'MG',
	MWI: 'MW',
	MYS: 'MY',
	MDV: 'MV',
	MLI: 'ML',
	MLT: 'MT',
	MHL: 'MH',
	MTQ: 'MQ',
	MRT: 'MR',
	MUS: 'MU',
	MYT: 'YT',
	MEX: 'MX',
	FSM: 'FM',
	MID: 'MI',
	MDA: 'MD',
	MCO: 'MC',
	MNG: 'MN',
	MNE: 'ME',
	MSR: 'MS',
	MAR: 'MA',
	MOZ: 'MZ',
	MMR: 'MM',
	NAM: 'NA',
	NRU: 'NR',
	NPL: 'NP',
	NLD: 'NL',
	ANT: 'AN',
	NTZ: 'NT',
	NCL: 'NC',
	NHB: 'NH',
	NZL: 'NZ',
	NIC: 'NI',
	NER: 'NE',
	NGA: 'NG',
	NIU: 'NU',
	NFK: 'NF',
	MKD: 'MK',
	MNP: 'MP',
	NOR: 'NO',
	OMN: 'OM',
	OTH: 'OT',
	PCI: 'PI',
	PAK: 'PK',
	PLW: 'PW',
	PSE: 'PS',
	PAN: 'PA',
	PCZ: 'PC',
	PNG: 'PG',
	PRY: 'PY',
	PER: 'PE',
	PHL: 'PH',
	PHI: 'PH',
	PCN: 'PN',
	POL: 'PL',
	PRT: 'PT',
	PRI: 'PR1',
	QAT: 'QA',
	REU: 'RE',
	ROU: 'RO',
	ROM: 'RO',
	RUS: 'RU',
	RWA: 'RW',
	BLM: 'BL',
	SHN: 'SH',
	KNA: 'KN',
	LCA: 'LC',
	MAF: 'MF',
	SPM: 'PM',
	VCT: 'VC',
	WSM: 'WS',
	SMR: 'SM',
	STP: 'ST',
	SAU: 'SA',
	SEN: 'SN',
	SRB: 'RS',
	SCG: 'CS',
	SYC: 'SC',
	SLE: 'SL',
	SKM: 'SK',
	SGP: 'SG',
	SXM: 'SX',
	SVK: 'SK',
	SVN: 'SI',
	SLB: 'SB',
	SOM: 'SO',
	ZAF: 'ZA',
	SGS: 'GS',
	SSD: 'SS',
	RHO: 'ZW',
	ESP: 'ES',
	LKA: 'LK',
	SDN: 'SD',
	SUR: 'SR',
	SJM: 'SJ',
	SWE: 'SE',
	CHE: 'CH',
	SYR: 'SY',
	TWN: 'TW',
	TJK: 'TJ',
	TZA: 'TZ',
	THA: 'TH',
	TLS: 'TL',
	TGO: 'TG',
	TKL: 'TK',
	TON: 'TO',
	TTO: 'TT',
	TAA: 'TA',
	TUN: 'TN',
	TUR: 'TR',
	TKM: 'TM',
	TCA: 'TC',
	TUV: 'TV',
	UGA: 'UG',
	UKR: 'UA',
	ARE: 'AE',
	GBR: 'UK',
	USA: 'US',
	URY: 'UY',
	UZB: 'UZ',
	VUT: 'VU',
	VEN: 'VE',
	VNM: 'VN',
	WLF: 'WF',
	YEM: 'YE',
	ZMB: 'ZM',
	ZWE: 'ZW',
	IOT: 'IO',
	VIR: 'VI',
	DOM: 'DO1',
	VGB: 'VG'
};

const reverseCountryCodeMap: Record<string, string> = Object.fromEntries(
	Object.entries(countryCodeMap).map(([threeLetterCode, twoLetterCode]) => [twoLetterCode, threeLetterCode])
);

const getThreeLetterCode = (twoLetterCode: string): string | undefined => {
	if (twoLetterCode === 'DO2' || twoLetterCode === 'DO3') return 'DOM';
	if (twoLetterCode === 'PR2') return 'PRI';
	return reverseCountryCodeMap[twoLetterCode];
};
